/**
 * Disabled-user helpers.
 *
 * Users have no "disabled" flag: disableDashboardUser deletes every ENABLED role item they
 * have, and the backend's isDashboardEnabled rule treats that item as the account's on/off
 * switch. So "has an ENABLED role item" is the only signal that an account is still active.
 */

/** Add to the AND array of a users() where clause to exclude disabled users server-side. */
export const ENABLED_USER_FILTER = {
  roles_some: { roleItems_some: { feature: 'ENABLED' } },
};

/**
 * Client-side counterpart, for user lists that come off a relation (team members, project
 * owner/team) instead of the users() query. Requires `roles { roleItems { feature } }` in the
 * selection set; fails open when that data is absent, so a user is only ever hidden when we can
 * positively prove they are disabled.
 */
export const isEnabledUser = (user) => {
  const roles = user && user.roles;
  if (!Array.isArray(roles) || !roles.some((role) => Array.isArray(role.roleItems))) return true;
  return roles.some((role) =>
    (role.roleItems || []).some((item) => item.feature === 'ENABLED')
  );
};

export const filterEnabledUsers = (users) => (users || []).filter(isEnabledUser);
